// language=GraphQL
export const ALL_TRAVEL_TYPES_QUERY = `query Query($withImage: Boolean = false) {
  travelTypes: travelTypes {
    id
    name
    description
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_TYPE_QUERY = `query Query($id: ID!, $withImage: Boolean = false) {
  travelType: travelType(id: $id) {
    id
    name
    description
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_TYPE_MUTATION = `
  mutation Mutation($input: CreateTravelTypeInput, $withImage: Boolean = false) {
    travelType: createTravelType(input: $input) {
      id
      name
      description
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TYPE_MUTATION = `
  mutation Mutation($input: UpdateTravelTypeInput, $withImage: Boolean = false) {
    travelType: updateTravelType(input: $input) {
      id
      name
      description
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TYPE_MUTATION = `
  mutation Mutation($input: DeleteTravelTypeInput) {
    deleteTravelType(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_TYPE_MUTATION = `
  mutation Mutation($input: DeleteTravelTypeInput) {
    forceDeleteTravelType(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TRAVEL_TYPES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false, $withCmsPrefilteredTravelsBlocks: Boolean = false, $withTravelObjectTenantSettings: Boolean = false) {
  groupedDependents: travelTypeDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
    cmsPrefilteredTravelsBlocks @include(if: $withCmsPrefilteredTravelsBlocks) {
      id
      maxResults    }
    travelObjectTenantSettings @include(if: $withTravelObjectTenantSettings) {
      id
      onlineStatus
      redirectToBooking
      useTiming
      startDate
      endDate
    }
  }
}`
